export default {
	namespaced: true,
  state: {
    shops: [],
    selectedShop: null,
  },
  mutations: {
    setShops(state, list) {
      state.shops = list;
    },
    selectShop(state, shopId) {
      const shopData = state.shops.find(s => s.id == shopId);
      state.selectedShop = shopData || null;
    },
  },
  actions: {
    async loadShops(context) {
      try {
        const res = await fetch(
          process.env.VUE_APP_API_SERVER + "shops", {credentials: "include"}
        );
        const shops = await res.json();
        context.commit("setShops", shops)
      }
      catch(ex) {
        context.commit('err/setErrorMessage', "by loadShops", { root: true });
      }
    }
  },
  getters: {
    selectedShopId: (state) => state.selectedShop ? state.selectedShop.id : 0,
    selectedShopName: state => state.selectedShop ? state.selectedShop.name : "",
  }
}
